import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "papersizes"
    }}>{`PaperSizes`}</h1>
    <p>{`Paper size optons.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`DEFINED_BY_DRIVER`}</strong>{` = 1347634290`}</p>
      <p parentName="blockquote">{`Allows the printer driver to define the paper size.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CUSTOM`}</strong>{` = 1131639917`}</p>
      <p parentName="blockquote">{`Allows definition of a custom paper size. Note: Not all printers allow custom paper sizes.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      